export default "__VITE_ASSET__DXGNHjPb__"